import { render } from "./DashboardInquiry.vue?vue&type=template&id=56d4c6e8&scoped=true"
import script from "./DashboardInquiry.vue?vue&type=script&lang=js"
export * from "./DashboardInquiry.vue?vue&type=script&lang=js"

import "./DashboardInquiry.vue?vue&type=style&index=0&id=56d4c6e8&scoped=true&lang=css"

import exportComponent from "D:\\Repos\\c2stem\\c2stem-classroom-inquiry\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56d4c6e8"]])

export default __exports__